import { bindActionCreators } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";
import { reportAxios } from "ultis/axios";

export const GET_LIST_REPORT_EXTENSION = "GET_LIST_REPORT_EXTENSION";
export const GET_LIST_REPORT_EXTENSION_ERROR =
  "GET_LIST_REPORT_EXTENSION_ERROR";
export const GET_LIST_REPORT_EXTENSION_SUCCESS =
  "GET_LIST_REPORT_EXTENSION_SUCCESS";

export const COUNT_LIST_REPORT_EXTENSION = "COUNT_LIST_REPORT_EXTENSION";
export const COUNT_LIST_REPORT_EXTENSION_ERROR =
  "COUNT_LIST_REPORT_EXTENSION_ERROR";
export const COUNT_LIST_REPORT_EXTENSION_SUCCESS =
  "COUNT_LIST_REPORT_EXTENSION_SUCCESS";
export const GET_PROVINCE_TYPES = "GET_PROVINCE_TYPES";
export const GET_PROVINCE_TYPES_SUCCESS = "GET_PROVINCE_TYPES_SUCCESS";
export const GET_PROVINCE_TYPES_ERROR = "GET_PROVINCE_TYPES_ERROR";

export const GET_EXTENSION_CONTACT_CENTERS = "GET_EXTENSION_CONTACT_CENTERS";
export const GET_EXTENSION_CONTACT_CENTERS_SUCCESS =
  "GET_EXTENSION_CONTACT_CENTERS_SUCCESS";
export const GET_EXTENSION_CONTACT_CENTERS_ERROR =
  "GET_EXTENSION_CONTACT_CENTERS_ERROR";

const initialState = {
  report: [],
  error: false,
  count: 0,
  loading: false,
  provinceTypes: [],
  loadingProvinceTypes: false,

  extensionContactCenters: [],
  loadingExtensionContactCenters: false,
};

export const reportExtensionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_REPORT_EXTENSION:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_EXTENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };
    case GET_LIST_REPORT_EXTENSION_ERROR:
      return {
        ...state,
        report: action.error,
        loading: false,
      };
    case COUNT_LIST_REPORT_EXTENSION:
      return {
        ...state,
      };
    case COUNT_LIST_REPORT_EXTENSION_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_REPORT_EXTENSION_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case GET_PROVINCE_TYPES:
      return {
        ...state,
        loadingProvinceTypes: true,
      };

    case GET_PROVINCE_TYPES_SUCCESS:
      return {
        ...state,
        provinceTypes: action.payload,
        loadingProvinceTypes: false,
      };

    case GET_PROVINCE_TYPES_ERROR:
      return {
        ...state,
        error: action.error,
        loadingProvinceTypes: false,
      };

    case GET_EXTENSION_CONTACT_CENTERS:
      return {
        ...state,
        loadingExtensionContactCenters: true,
      };

    case GET_EXTENSION_CONTACT_CENTERS_SUCCESS:
      return {
        ...state,
        extensionContactCenters: action.payload,
        loadingExtensionContactCenters: false,
      };

    case GET_EXTENSION_CONTACT_CENTERS_ERROR:
      return {
        ...state,
        error: action.error,
        loadingExtensionContactCenters: false,
      };

    default:
      return state;
  }
};

/**
 * Action
 */
export const getListReportExtension = (params) => ({
  type: GET_LIST_REPORT_EXTENSION,
  data: params,
});

export const getProvinceTypes = (params) => ({
  type: GET_PROVINCE_TYPES,
  data: params,
});

export const getExtensionContactCenters = (params) => ({
  type: GET_EXTENSION_CONTACT_CENTERS,
  data: params,
});

export const getListReportExtensionApi = (body) => {
  return reportAxios.post("/api/v1/reports/extension", body);
};

export const getProvinceTypesApi = (params) => {
  return reportAxios.get(`/api/v1/provinces/type`, { params });
};

const getExtensionContactCentersApi = (params) => {
  return reportAxios.get("/api/v1/provinces/report-extension", {
    params,
  });
};

export const getListReportExtensionSaga = function* (action) {
  try {
    const res = yield call(getListReportExtensionApi, action.data);

    const detailReport = res.data.data?.detailReport?.reduce((prev, item) => {
      item.extension.forEach((element) => {
        prev.push({
          contactCenterCode: item.code,
          contactCenterName: item.name,
          extensionName: element.name,
          ...element,
        });
      });
      return prev;
    }, []);

    yield put({
      type: GET_LIST_REPORT_EXTENSION_SUCCESS,
      payload: { ...res.data.data, detailReport },
    });
  } catch (error) {
    yield put({ type: GET_LIST_REPORT_EXTENSION_ERROR, error });
  }
};

export const getListReportExtensionFlow = function* () {
  yield takeLatest(GET_LIST_REPORT_EXTENSION, getListReportExtensionSaga);
};

const getProvinceTypesSaga = function* (action) {
  try {
    const res = yield call(getProvinceTypesApi, action.data);
    yield put({ type: GET_PROVINCE_TYPES_SUCCESS, payload: res.data.data });
  } catch (error) {
    yield put({ type: GET_PROVINCE_TYPES_ERROR, error });
  }
};

export const getProvinceTypesFlow = function* () {
  yield takeLatest(GET_PROVINCE_TYPES, getProvinceTypesSaga);
};

const getExtensionContactCentersSaga = function* (action) {
  try {
    const res = yield call(getExtensionContactCentersApi, action.data);
    yield put({
      type: GET_EXTENSION_CONTACT_CENTERS_SUCCESS,
      payload: res.data.data,
    });
  } catch (error) {
    yield put({ type: GET_EXTENSION_CONTACT_CENTERS_ERROR, error });
  }
};

export const getExtensionContactCentersFlow = function* () {
  yield takeLatest(
    GET_EXTENSION_CONTACT_CENTERS,
    getExtensionContactCentersSaga
  );
};

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getExtensionContactCenters,
      getProvinceTypes,
    },
    dispatch
  );
};
